import { AuthProvider, DateFnsProvider, QueryClientProvider, RouterProvider, SnackbarProvider, ThemeProvider } from './providers';

function App() {
  return (
    <ThemeProvider>
      <SnackbarProvider>
        <QueryClientProvider>
          <AuthProvider>
            <DateFnsProvider>
              <RouterProvider />
            </DateFnsProvider>
          </AuthProvider>
        </QueryClientProvider>
      </SnackbarProvider>
    </ThemeProvider>
  );
}

export default App;
